import * as React from 'react';

import {Body} from '../../typography/body';

type Props = {
    text: string;
};

export function AiHomepageDescription(props: Props) {
    return (
        <Body size='large' maintainLineBreaks={true}>
            {props.text}
        </Body>
    );
}
